import { GetEmployeeBalanceResponse } from '@Common/types/b2b/balance';
import { GetB2bEmployeesOneResponse } from '@Common/types/bo/b2b/employees';
import { B2bCompanyPlanTypeParameters } from '@Common/types/bo/b2b/plans';

import { b2bEmployeesTranslations } from '@sh4res/bo-common/i18n/en/b2b/employees';

export const employeesTranslations = {
  subtitle: 'Account number #%{id}',
  fields: b2bEmployeesTranslations.fields,
  status: {
    current: 'Current',
    past: 'Past',
    retired: 'Retired',
  } satisfies Record<GetB2bEmployeesOneResponse['status'], string>,
  social_status: {
    TS: 'TS',
    TNS: 'TNS',
  } satisfies Record<GetB2bEmployeesOneResponse['social_status'], string>,
  leaving_reason: {
    decease: 'Decease',
    job_transfer: 'Job transfer',
    other: 'Other',
    retirement: 'Retirement',
    work_ended: 'Work ended',
  } satisfies Record<Exclude<GetB2bEmployeesOneResponse['leaving_reason'], null>, string>,
  tabs: {
    details: {
      label: 'Details',
      sections: {
        details: 'Details',
        personal: 'Personal info',
        work: 'Work',
        company: 'Company',
        financial: 'Financial',
        account: 'Account',
      },
    },
    orders: {
      label: 'Orders',
      error: 'Failed to retrieve employee orders',
      no_plans: 'No plans set up for the company',
    },
    savings: {
      label: 'Savings',
      no_plans: 'No plans set up for the company',
      not_linked: 'Employee has not been linked yet to any Shares user',
      sections: {
        balance: 'Balance',
        portfolio: 'Portfolio',
      },
    },
    abondements: {
      label: 'Abondements',
      error: 'Failed to retrieve employee Abondements',
      no_plans: 'No plans set up for the company',
      no_eligible_plans: 'User is not eligible for any company matching contributions',
      employment_inactive:
        'Employee is not eligible anymore for the company matching contributions because they ended their employment at the company',
      matching_contribution: 'Contribution',
      this_plan: 'This plan',
      remaining: 'Remaining',
      available_until: 'Available until',
      annual_ceiling: 'Annual plan ceiling',
      legal_ceiling: 'Legal ceiling (%{percentage}% PASS)',
      matching_rate: 'Matching rate',
      plan_type: {
        PEI: B2bCompanyPlanTypeParameters.PEI.name,
        PERECOI: B2bCompanyPlanTypeParameters.PERECOI.name,
      },
    },
  },
  balance: {
    fields: {
      id: 'ID',
      withdrawable_balance: 'Withdrawable Savings',
      booked_in_orders: 'Blocked by Orders',
      total_balance: 'Savings',
      locked_balance: 'Locked Savings',
      unsettled_balance: 'Unsettled Cash',
      user_id: 'User ID',
      currency: 'Currency',
    } satisfies Record<keyof GetEmployeeBalanceResponse, string>,
  },
};
